(function () {
  const sections = document.querySelectorAll('[data-sw-science]');
  if (!sections.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const parseStatNumber = (text) => {
    const match = String(text).trim().match(/^([\d,.]+)(.*)$/);
    if (!match) return null;

    const raw = match[1].replace(/,/g, '');
    const value = Number.parseFloat(raw);
    if (Number.isNaN(value)) return null;

    const decimals = raw.includes('.') ? raw.split('.')[1].length : 0;
    return { value, suffix: match[2], decimals };
  };

  const formatStatNumber = (value, suffix, decimals) => {
    const formatted = decimals > 0 ? value.toFixed(decimals) : String(Math.round(value));
    return `${formatted}${suffix}`;
  };

  const animateCount = (el, duration = 1600) => {
    const parsed = parseStatNumber(el.dataset.swScienceCount || el.textContent);
    if (!parsed) return;

    const { value, suffix, decimals } = parsed;
    const start = performance.now();

    const frame = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = formatStatNumber(value * eased, suffix, decimals);

      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = formatStatNumber(value, suffix, decimals);
      }
    };

    requestAnimationFrame(frame);
  };

  sections.forEach((section) => {
    const counters = section.querySelectorAll('[data-sw-science-count]');

    if (prefersReducedMotion) {
      section.classList.add('is-inview');
      return;
    }

    counters.forEach((counter) => {
      const parsed = parseStatNumber(counter.dataset.swScienceCount || counter.textContent);
      if (parsed) {
        counter.textContent = formatStatNumber(0, parsed.suffix, parsed.decimals);
      }
    });

    const reveal = () => {
      section.classList.add('is-inview');
      counters.forEach((counter, index) => {
        window.setTimeout(() => animateCount(counter), 180 + index * 120);
      });
    };

    const isInView = () => {
      const rect = section.getBoundingClientRect();
      return rect.top < window.innerHeight * 0.88 && rect.bottom > window.innerHeight * 0.08;
    };

    if (isInView()) {
      reveal();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal();
          observer.unobserve(section);
        });
      },
      { threshold: 0.22, rootMargin: '0px 0px -8% 0px' }
    );

    observer.observe(section);
  });
})();
